import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type {
	StarterDashboardV2PetitionTaskMutation,
	StarterDashboardV2PetitionTaskMutationVariables,
} from './completePetitionTask.graphql';
import { StarterDashboardV2PetitionTask } from './completePetitionTask.graphql';
import { COMPLETE_TASK_ERROR_MAP } from './constants';

type CompletePetitionTaskReturn = { success: boolean };
export async function completePetitionTask(
	id: string,
	{ errorReporter, gql: { fetch } }: UtilityContext,
): Promise<CompletePetitionTaskReturn> {
	const { data, requestId } = await fetch<
		StarterDashboardV2PetitionTaskMutation,
		StarterDashboardV2PetitionTaskMutationVariables
	>({
		query: StarterDashboardV2PetitionTask,
		variables: { input: { taskId: id } },
		rejectOnError: true,
	});

	if (data.completePetitionTask.__typename === 'CompletePetitionTaskError') {
		const errorCode =
			data.completePetitionTask.errorCode ??
			(data.completePetitionTask.message === 'Unauthorized'
				? COMPLETE_TASK_ERROR_MAP.UNAUTHORIZED_ERROR.code
				: COMPLETE_TASK_ERROR_MAP.UNKNOWN_ERROR.code);

		switch (data.completePetitionTask.message) {
			case 'Unauthorized': {
				const err = new Error(COMPLETE_TASK_ERROR_MAP.UNAUTHORIZED_ERROR.code);
				void errorReporter.report({
					error: new Error('Failed to complete petition task'),
					context: {
						requestId,
						reason: COMPLETE_TASK_ERROR_MAP.UNAUTHORIZED_ERROR.code,
					},
				});
				throw err;
			}
			default: {
				const err = new Error(errorCode);

				if (errorCode !== COMPLETE_TASK_ERROR_MAP.ALREADY_COMPLETED_ERROR.code) {
					void errorReporter.report({
						error: new Error('Failed to complete petition task'),
						context: {
							requestId,
							reason: errorCode,
						},
					});
				}

				throw err;
			}
		}
	}

	return { success: true };
}
